module.exports = __webpack_public_path__ + "resource/img/ionicons.svg?621bd386841f74e0053cb8e67f8a0604";


//////////////////
// WEBPACK FOOTER
// ./node_modules/iview/dist/styles/fonts/ionicons.svg?v=2.0.0
// module id = 561
// module chunks = 36